export default __webpack_public_path__ + "static/media/translations.b4e780cb.csv";